import Decimal from "decimal.js";

function isDecimal(value: string) {
  return value.indexOf('$dec_') === 0;
}
function toDecimal(value: string) {
  return new Decimal(value.substring(5));
}

const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|\+00:00)$/;

export default function (jsonString: string) {
  return JSON.parse(jsonString,
    (key, value) => {
      // Core support:
      if (typeof value === 'number')
      {
        return new Decimal(value);
      }
      if (typeof value === 'string' && isoDateRegex.test(value)) {
        return new Date(value);
      }


      // Legacy support:
      if (typeof value === 'string' && isDecimal(value.toString())) {
        return toDecimal(value);
      }

      if (key.endsWith('Utc') && typeof value === 'string') {
        return new Date(value);
      }
      
      return value;
    }
  );
}